module.exports = __webpack_public_path__ + "media/images/lb/999-b9def77c765b22223e26d9c3360b9f73.svg";